<template>
  <div>
    <sweet-modal ref="fields" class="modal-settings-item" :width="(internal_config.isDrip) ? '' : '750px'" :title="$t('ct-menu-settings')" v-if="internal_config">
      <span class="text__subtitle d-block mb-2">{{ $t('ct-items')}}</span>

      <div class="submenu-settings-content__items" v-if="internal_config.itemList && internal_config.itemList.length" :key="keyComponent">
        <div class="submenu-settings-content__item"
             v-for="(field,index) in internal_config.itemList"
             :class="{'animated flash': internal_config.fieldAnimated, 'with-drip': internal_config.isDrip}"
             :key="`menu-item-${index}`"
             @animationend="internal_config.fieldAnimated = false"
        >
          <div class="submenu-settings-content__item--label">
            <i
              class="mdi"
              v-if="field.icon && field.icon.selected && field.icon.position === 'left'"
              :class="field.icon.selected"></i>
            <span class="text__simple-text">{{field.name}}</span>
            <i
              class="mdi"
              v-if="field.icon && field.icon.selected && field.icon.position === 'right'"
              :class="field.icon.selected"></i>
          </div>

          <div class="submenu-settings-content__item--is-drip" v-if="internal_config.isDrip">
            <strong>{{ $t('ct-release-date') }}</strong>
            <span>
            {{typeof field.typeOfPredefined !== 'undefined' && field.typeOfPredefined !== 'none' ?
            (field.typeOfPredefined === 'date' ?momentConvert(field.datePredefined):dateFormatThis(field)) :
              $t('ct-released')}}</span>
          </div>

          <div class="submenu-settings-content__item--actions">

            <i class="mdi mdi-chevron-down text-secondary"
               v-tooltip="{content:$t('ct-option-down'),  class: 'tooltip-custom'}"
               @click="changePosition(index, index+1)"
            />

            <i class="mdi mdi-chevron-up text-secondary"
               v-tooltip="{content:$t('ct-option-up'),  class: 'tooltip-custom'}"
               @click="changePosition(index, index-1)"
            />

            <i class="mdi mdi-link text-success"
               v-tooltip="{content:$t('ct-option-link'),  class: 'tooltip-custom'}"
               @click="editLink(field)"
            />

            <i class="mdi mdi-pencil text-primary"
               v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
               @click="editField(field)"
            />

            <font-awesome-icon
              v-if="internal_config.isDrip"
              :icon="['fas', 'clock']"
              v-tooltip="{content:$t('ct-set-time'),  class: 'tooltip-custom'}"
              class="font-awesome-icon text-info"
              @click="changeTime(field)"
            />

            <i class="ct-icon-trash text-danger"
               v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
               @click="internal_config.itemList.splice(index,1)"
            />
          </div>
        </div>
      </div>

      <div class="submenu-settings-content__item-empty" v-else>
        <p>{{ $t('ct-items-is-empty') }}</p>
      </div>

      <button class="btn btn-primary btn-lg btn-action-add w-100 mx-0" @click="openAddField()">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>{{ $t('ct-item') }}
      </button>

      <button
        slot="button"
        class="btn btn-outline-light"
        @click="cancelAll()"
      >{{ $t('ct-cancel') }}
      </button>
      <button
        slot="button"
        class="btn btn-success"
        @click="saveAll()"
      ><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}
      </button>
      <!--        <button slot="button" class="btn btn-success" @click="save">Save</button>-->
    </sweet-modal>

    <sweet-modal ref="addField" class="modal-settings-item" width="700px" :title="$t('ct-add-field')">
      <div class="label-icon-settings-content">
        <div class="label-icon-settings-content__field">
          <label class="text__simple-text">{{ $t('ct-label') }}</label>
          <input
            type="text"
            class="form-control"
            v-model="internal_config.itemEdition.name"/>
        </div>

        <div class="label-icon-settings-content__action-icon">
          <button class="btn btn-primary btn-lg btn-action-add ml-2" @click="selectIcon('item')">
            <font-awesome-icon
            :icon="['fas', 'plus-circle']"
            class="font-awesome-icon mr-2"
          />{{ (typeof internal_config.itemEdition.icon != 'undefined' && internal_config.itemEdition.icon.selected) ? $t('ct-change-icon') : $t('ct-add-icon')}}
          </button>
          <button class="btn btn-danger btn-lg px-4"
                  v-show="typeof internal_config.itemEdition.icon != 'undefined' && internal_config.itemEdition.icon.selected"
                  @click="removeIcon('item')"
          >
            <i class="svg-icon svgi-delete svgi-light m-0" v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"/>
          </button>
        </div>
      </div>

      <div class="icon-settings-content-align"
           v-show="typeof internal_config.itemEdition.icon != 'undefined' && internal_config.itemEdition.icon && typeof internal_config.itemEdition.icon.selected != 'undefined'">
        <div class="form-group" v-if="internal_config.itemEdition.icon">
          <label class="text__simple-text">{{ $t('ct-align') }}</label>
          <div class="btn-icon-group" v-if="!isEmptyObj(internal_config.itemEdition.icon)">
            <button
              class="btn-icon-align"
              :class="{'active' : typeof internal_config.itemEdition.icon != 'undefined' && internal_config.itemEdition.icon.position === 'left'}"
              @click="changeIconPosition('left', 'item')"
            >
              <i :class="['mdi', internal_config.itemEdition.icon.selected]"/>
              <span>{{ $t('ct-left') }}</span>
              <i class="input-radio-icon"/>
            </button>
            <button
              class="btn-icon-align"
              :class="{'active' : typeof internal_config.itemEdition.icon != 'undefined' && internal_config.itemEdition.icon.position === 'right'}"
              @click="changeIconPosition('right', 'item')"
            >
              <span>{{ $t('ct-right') }}</span>
              <i :class="['mdi', internal_config.itemEdition.icon.selected]"/>
              <i class="input-radio-icon"/>
            </button>
          </div>
        </div>
      </div>

      <div class="submenu-settings-content">
        <span class="text__subtitle d-block mb-2">{{ $t('ct-sub-menus') }}</span>
        <div class="submenu-settings-content__items" v-if="internal_config.itemEdition.children && internal_config.itemEdition.children.length">
          <div class="submenu-settings-content__item"
               v-for="(field,index) in internal_config.itemEdition.children"
               :class="{'animated flash': internal_config.fieldAnimated}"
          >
            <div class="submenu-settings-content__item--label">
              <i
                class="mdi"
                v-show="field.icon && field.icon.selected && field.icon.position === 'left'"
                :class="field.icon.selected"></i>
              <span class="text__simple-text">{{field.name}}</span>
              <i
                class="mdi"
                v-show="field.icon && field.icon.selected && field.icon.position === 'right'"
                :class="field.icon.selected"></i>
            </div>

            <div class="submenu-settings-content__item--actions">

              <i class="mdi mdi-chevron-down text-secondary"
                 v-tooltip="{content:$t('ct-option-up'),  class: 'tooltip-custom'}"
                 @click="changePositionSubmenu(index, index-1)"
              />

              <i class="mdi mdi-chevron-up text-secondary"
                 v-tooltip="{content:$t('ct-option-up'),  class: 'tooltip-custom'}"
                 @click="changePositionSubmenu(index, index-1)"
              />

              <i class="mdi mdi-link text-success"
                 v-tooltip="{content:$t('ct-option-link'),  class: 'tooltip-custom'}"
                 @click="editLink(field)"
              />

              <i class="mdi mdi-pencil text-primary"
                 v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
                 @click="editChild(field)"
              />

              <i class="ct-icon-trash text-danger"
                 v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
                 @click="internal_config.itemEdition.children.splice(index,1)"
              />
            </div>
          </div>
        </div>
        <div class="submenu-settings-content__item-empty" v-else>
          <p>{{ $t('ct-sub-menu-is-empty') }}</p>
        </div>
      </div>

      <button
        class="btn btn-primary btn-lg btn-action-add w-100 m-0"
        @click="createNewSubItem()"
      >
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>{{ $t('ct-sub-menu') }}
      </button>

      <button
        slot="button"
        class="btn btn-outline-light"
        @click="$refs.addField.close()"
      >{{ $t('ct-cancel')}}
      </button>
      <button slot="button" class="btn btn-success" @click="save"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>
    </sweet-modal>

    <sweet-modal ref="addChild" class="modal-settings-item" width="680px" :title="$t('ct-subitem-add')">
      <div class="label-icon-settings-content">
        <div class="label-icon-settings-content__field">
          <label for="name-subitem" class="text__simple-text">{{ $t('ct-name') }}</label>
          <input
            type="text"
            class="form-control"
            name="name-subitem"
            id="name-subitem"
            v-model="internal_config.subitemEdition.name"
          />
        </div>
        <div class="label-icon-settings-content__action-icon">
          <button class="btn btn-primary btn-lg btn-action-add ml-2" @click="selectIcon('subitem')">
            <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              class="font-awesome-icon mr-2"
            />{{$t('ct-add-icon')}}
          </button>

          <template v-if="typeof internal_config.subitemEdition.icon !== 'undefined' && !isEmptyObj(internal_config.subitemEdition.icon) && typeof internal_config.subitemEdition.icon.selected !== 'undefined'">
            <button class="btn btn-danger btn-lg"
                    @click="removeIcon('subitem')"
            >
              <i class="svg-icon svgi-delete svgi-light m-0" v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"/>
            </button>
          </template>
        </div>
      </div>

      <div class="icon-settings-content-align"
           v-if="typeof internal_config.subitemEdition.icon != 'undefined' && internal_config.subitemEdition.icon &&
            !isEmptyObj(internal_config.subitemEdition.icon)">
        <div class="form-group">
          <label class="text__simple-text">{{ $t('ct-align') }}</label>
          <div class="btn-icon-group">
            <button
              class="btn-icon-align"
              :class="{'active' : internal_config.subitemEdition.icon.position === 'left'}"
              @click="changeIconPosition('left', 'subitem')"
            >
              <i :class="['mdi', internal_config.subitemEdition.icon.selected]"/>
              <span>{{ $t('ct-left') }}</span>
              <i class="input-radio-icon"/>
            </button>
            <button
              class="btn-icon-align"
              :class="{'active' : internal_config.subitemEdition.icon.position === 'right'}"
              @click="changeIconPosition('right', 'subitem')"
            >
              <span>{{ $t('ct-right') }}</span>
              <i :class="['mdi', internal_config.subitemEdition.icon.selected]"/>
              <i class="input-radio-icon"/>
            </button>
          </div>
        </div>
      </div>


      <button
        slot="button"
        class="btn btn-outline-light"
        @click="$refs.addChild.close()"
      >{{ $t('ct-cancel')}}
      </button>
      <button slot="button" class="btn btn-success" @click="addChild"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>
    </sweet-modal>

    <sweet-modal ref="setTime" class="modal-settings-item" width="550px" :title="setTimeEditionField.name">
      <div class="form-group">
        <label class="text__simple-text">
          {{$t('ct-type-liberation')}}
          <select class="form-control" v-model="setTimeEditionField.typeOfPredefined" @change="showOptionsTime">
            <option value="none">{{$t('ct-type-liberation-none')}}</option>
            <option value="date">{{$t('ct-type-liberation-date')}}</option>
            <option value="time">{{$t('ct-type-liberation-time')}}</option>
          </select>
        </label>

        <div class="set-time-drip-options set-time-drip-date" style="display: none;">
          <label class="text__simple-text">{{$t('ct-type-liberation-date-explain')}}</label>
          <input class="form-control" type="datetime-local" v-model="setTimeEditionField.datePredefined">
        </div>

        <div class="set-time-drip-options set-time-drip-time" style="display: none">
          <p class="text__simple-text">{{$t('ct-type-liberation-time-explain')}}</p>
          <label style="width: 22% !important;">
            {{$t('ct-days')}}
            <input class="form-control" type="number" min="0" max="364"
                   @change="handleInput($event,'timePredefinedDays')"
                   v-model="setTimeEditionField.timePredefinedDays">
          </label>
          <label class=" text__simple-text w-25">
            {{$t('ct-hours')}}
            <input class="form-control" type="number" min="0" max="23"
                   @change="handleInput($event,'timePredefinedHours')"
                   v-model="setTimeEditionField.timePredefinedHours">
          </label>
          <label class=" text__simple-text w-25">
            {{$t('ct-minutes')}}
            <input class="form-control" type="number" min="0" max="59"
                   @change="handleInput($event,'timePredefinedMinutes')"
                   v-model="setTimeEditionField.timePredefinedMinutes">
          </label>
          <label class="text__simple-text w-25">
            {{$t('ct-seconds')}}
            <input class="form-control" type="number" min="0" max="59"
                   @change="handleInput($event,'timePredefinedSeconds')"
                   v-model="setTimeEditionField.timePredefinedSeconds">
          </label>
        </div>
      </div>

      <button slot="button" class="btn btn-success" @click="saveSchedule()"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>
    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import moment from 'moment/moment';
import _ from 'lodash';

export default {
  name: 'MenuConfigModals',
  components: {
    SweetModal
  },
  data() {
    return {
      keyComponent: 1,
      name: 'menu',
      internal_config: {
        itemEdition: {
          name: ''
        },
        subitemEdition: {
          name: ''
        }
      },
      internal_config_current: false,
      callback: false,
      setTimeEditionField: {
        namenamename: '',
        typeOfPredefined: 'none', // date, timeFirstAccess
        datePredefined: new Date(),
        timePredefinedDays: 0,
        timePredefinedHours: 0,
        timePredefinedMinutes: 0,
        timePredefinedSeconds: 0
      }
    };
  },
  methods: {
    forceUpdate() {
      this.keyComponent += 1;
    },

    isEmptyObj(obj) {
      if(obj.constructor === Object)
        return Object.keys(obj).length === 0

      return obj;
    },

    saveSchedule() {
      if (typeof this.setTimeEditionField.timePredefinedDays === 'undefined') { this.setTimeEditionField.timePredefinedDays = 0 }
      if (typeof this.setTimeEditionField.timePredefinedHours === 'undefined') { this.setTimeEditionField.timePredefinedHours = 0 }
      if (typeof this.setTimeEditionField.timePredefinedMinutes === 'undefined') { this.setTimeEditionField.timePredefinedMinutes = 0 }
      if (typeof this.setTimeEditionField.timePredefinedSeconds === 'undefined') { this.setTimeEditionField.timePredefinedSeconds = 0 }

      this.$refs.setTime.close();

      this.forceUpdate();
    },
    dateFormatThis(field) {
      return field.timePredefinedDays + this.$t('ct-days') + ' ' +
          field.timePredefinedHours + this.$t('ct-hours') + ' ' +
          field.timePredefinedMinutes + this.$t('ct-minutes') + ' ' +
          field.timePredefinedSeconds + this.$t('ct-seconds');
    },
    momentConvert(value) {
      return moment(value).format('lll');
    },
    handleInput(event, variable) {
      let value = Number(event.target.value);
      if (value > event.target.max) {
        this.setTimeEditionField[variable] = event.target.max;
      } else if (value < event.target.min || Number.isNaN(value)) {
        this.setTimeEditionField[variable] = event.target.min;
      } else {
        this.setTimeEditionField[variable] = value;
      }
    },
    showOptionsTime() {
      $('.set-time-drip-options').hide();

      if (this.setTimeEditionField.typeOfPredefined === 'date') {
        $('.set-time-drip-date').show();
        $('.set-time-drip-time').hide();
      }

      if (this.setTimeEditionField.typeOfPredefined === 'time') {
        $('.set-time-drip-time').show();
        $('.set-time-drip-date').hide();
      }
    },

    createNewSubItem() {
      this.internal_config.subitemEdition = Object.assign(
        {},
        {
          name: '',
          type: 'add',
          icon: '',
          iconPosition: 'left',
          link: {
            type: 'web',
            value: '',
            target: '_blank',
            targetID: ''
          }
        }
      );
      this.$refs.addChild.open();
    },

    init(config, callback = false) {
      this.internal_config = config;
      this.internal_config_current = JSON.parse(JSON.stringify(config));
      this.callback = callback;
    },
    open(modal) {
      if (this.$refs[modal]) {
        this.$refs[modal].open();
      }
    },
    save() {
      if (this.internal_config.itemEdition['type'] == 'add') {
        this.internal_config.itemList.push(
          Object.assign({}, this.internal_config.itemEdition)
        );
      }

      this.$refs.addField.close();
    },

    saveAll() {
      if (this.callback && typeof this.callback === 'function') {
        this.callback(this.internal_config);
        this.$refs['fields'].close();
      }
    },

    cancelAll() {
      if (this.callback && typeof this.callback === 'function') {
        this.internal_config = this.internal_config_current;
        this.callback(this.internal_config_current);
        this.$refs['fields'].close();
        this.forceUpdate();
      }
    },

    openEdition() {
      this.$refs.fields.open();
    },

    editLink(field) {
      this.$root.$emit('linkComponentShow', this, field.link, value => {
        field.link = value;
      });
    },

    addChild() {
      if (this.internal_config.subitemEdition['type'] === 'add') {
        this.internal_config.itemEdition.children.push(
          Object.assign({}, this.internal_config.subitemEdition)
        );
      }

      this.$refs.addChild.close();
    },

    openAddField() {
      this.internal_config.itemEdition = Object.assign(
        {},
        {
          name: '',
          type: 'add',
          icon: '',
          iconPosition: 'left',
          children: [],
          link: {
            type: 'web',
            value: '',
            target: '_blank',
            targetID: ''
          }
        }
      );
      this.$refs.addField.open();
    },
    editField(field) {
      this.internal_config.itemEdition = field;
      this.internal_config.itemEdition['type'] = 'edit';
      this.$refs.addField.open();
    },
    changeTime(field) {
      // this.internal_config.itemEdition = field;
      // this.internal_config.itemEdition['type'] = 'edit';
      // this.$refs.addField.open();

      if (typeof field.typeOfPredefined === 'undefined') {
        field.typeOfPredefined = 'none';
        field.datePredefined = new Date();

        field.timePredefinedDays = 0;
        field.timePredefinedHours = 0;
        field.timePredefinedMinutes = 0;
        field.timePredefinedSeconds = 0;
      }

      this.setTimeEditionField = field;

      this.$refs.setTime.open();

      this.showOptionsTime();
    },
    editChild(field) {
      this.internal_config.subitemEdition = field;
      this.internal_config.subitemEdition['type'] = 'edit';
      this.$refs.addChild.open();
    },

    linkAction() {
      if (this.$props.preview) { this.$snotify.warning(this.$t('ct-only-works-on-publication')) }
    },
    animateField() {
      this.internal_config.fieldAnimated = true;
    },
    changePosition(index, newIndex) {
      if (newIndex >= this.internal_config.itemList.length || newIndex < 0) {
        return;
      }

      this.animateField();
      this.internal_config.itemList.splice(
        newIndex,
        0,
        this.internal_config.itemList.splice(index, 1)[0]
      );
    },
    changePositionSubmenu(index, newIndex) {
      if (
        newIndex >= this.internal_config.itemEdition.children.length ||
          newIndex < 0
      ) {
        return;
      }

      this.animateField();
      this.internal_config.itemEdition.children.splice(
        newIndex,
        0,
        this.internal_config.itemEdition.children.splice(index, 1)[0]
      );
    },
    selectIcon(element) {
      let _self = this;
      let selectIcon;

      window.vm.$root.$emit('showIconList', function(icon) {
        selectIcon = {selected: icon, position: 'left'};
        if (element === 'item') {
          _self.internal_config.itemEdition.icon = selectIcon;
        } else if (element === 'subitem') {
          _self.internal_config.subitemEdition.icon = selectIcon;
        }
      });
    },
    removeIcon(element) {
      if (element === 'item') {
        this.internal_config.itemEdition.icon = '';
      } else if (element === 'subitem') {
        this.internal_config.subitemEdition.icon = '';
      }
    },
    changeIconPosition(value, element) {
      if (element === 'item') {
        this.internal_config.itemEdition.icon.position = value;
      } else if (element === 'subitem') {
        this.internal_config.subitemEdition.icon.position = value;
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .nav-item {
    position: relative;
  }

  .navbar-nav.flex-column .dropdown-menu {
    left: 100%;
    top: 0;
  }

  .modal-settings-item {

    span, label {
      font-family: 'Lato', sans-serif;
      font-size: 16px;
      color: #6E6E6E;
    }

    .text {

      &__subtitle, &__simple-text {
        color: #6E6E6E;
      }

      &__subtitle {
        font-size: 18px;
      }

      &__simple-text {
        font-size: 16px;
      }
    }

  }

  .icon-settings-content-align {
    display: flex;

    &__selected {
      display: flex;
      flex-direction: column;
    }

    .form-group {

    }

    .form-group:last-child {
      flex: 1;
    }

    .btn-icon-group {
      display: flex;
      padding-top: 3px;

      .btn-icon-align {
        position: relative;
        flex: 1;
        background: #FAFBFC;
        border: 1px dashed #B0BFCE;
        border-radius: 5px;

        text-align: left;
        font-size: 14px;

        transition: .4s;

        padding: 10px 20px;

        &:hover, &.active, &:focus {
          border: 1px dashed #0080FC;
          outline: none;
        }

        i {
          margin: 0 5px;

          font-size: 18px;
          color: #0795ff;
        }

        .input-radio-icon {
          top: 8px;
          right: 5px;

          width: 15px;
          height: 15px;
        }
      }

      .btn-icon-align + .btn-icon-align {
        margin-left: 20px;
      }
    }
  }

  .label-icon-settings-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;

    @media (min-width: 576px) {
      flex-direction: row;
    }

    &__field {
      margin-bottom: 15px;

      input {
        height: 47px;
      }

      @media (min-width: 576px) {

        input {
          width: 270px;
        }
      }
    }

    &__action-icon {
      display: flex;

      @media (min-width: 576px) {
        justify-content: end;
        align-items: flex-end;

        margin-bottom: 15px;
      }
    }

  }

  .submenu-settings-content {

    &__items {
      background: #FFFFFF;
      border: 1px solid #DDDDDD;
      border-radius: 3px;

      padding: 15px 25px;
      margin-bottom: 15px;

      max-height: 50vh;
      overflow: auto;
    }

    &__item-empty {
      font-family: 'Lato', sans-serif;
      font-size: 16px;
      text-align: center;
      color: #6E6E6E;

      padding: 10px 0;

      p {
        background: #FAFBFC;
        border: 1px dashed #B0BFCE;
        border-radius: 5px;

        padding: 15px 0;
        margin-bottom: 0;
      }
    }

    &__item {
      display: grid;

      @media (min-width: 576px) {
        grid-template-columns: auto 160px;
        grid-column-gap: 10px;
        grid-template-areas: "label actions";
        align-items: center;

        &.with-drip {
          height: auto;
          min-height: 67px;
          grid-template-areas: "label drip actions";
          grid-template-columns: 1fr 1fr 180px;
        }

        min-height: 67px;
      }

      @media (max-width: 575px) {
        grid-template-columns: auto;
        grid-template-rows: auto;
        grid-row-gap: 5px;
        &.with-drip {
          grid-template-areas: "label" "drip" "actions";
        }
        grid-template-areas: "label" "actions";
      }

      &:not(:last-child) {
        padding-bottom: 5px;
      }

      &--label {
        display: inline-flex;
        align-items: center;

        background: #FAFBFC;
        border: 1px solid #DDDDDD;
        border-radius: 3px;

        height: 47px;

        padding-left: 20px;

        flex: 1;

        grid-area: label;

        span {
          font: normal normal medium 14px/35px Lato;
          color: #656565;

          max-width: 300px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        i {
          margin: 0 5px;

          font-size: 18px;
          color: #0795ff;
        }
      }

      &--is-drip {
        padding: 3px 0;
        grid-area: drip;

        strong {
          font-size: 12px;
          color: #434343;

          display: block;
        }

        span {
          font-size: 16px;
        }
      }

      &--actions {
        display: inline-flex;
        align-items: center;
        justify-content: end;

        grid-area: actions;

        i {
          cursor: pointer;
        }

        i.mdi:first-child {
          margin-right: 0;
        }

        i.mdi:nth-child(2) {
          margin-left: 0;
        }

        i.mdi {
          font-size: 28px;

          margin-left: 3px;
          margin-right: 3px;
        }

        i[class^="ct-icon-"] {
          font-size: 22px;

          margin-left: 3px;
          margin-right: 3px;

          display: inline-flex;
          vertical-align: middle;
        }

        .font-awesome-icon {
          font-size: 14px;

          margin-left: 5px;
          margin-right: 5px;
        }

        .mdi-link {
          transform: rotate(-50deg);
        }

        .text-success {
          color: #01D4B9 !important;
        }

        .text-primary {
          color: #0080FC !important;
        }
      }
    }

    .submenu-settings-content__item + .submenu-settings-content__item {
      padding-top: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Menu/ConfigModals.vue